import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { Button, Radio, RadioGroup, Text, VStack } from "@chakra-ui/react";
import React, { useState } from "react";
import { CherryPayApi } from "../api/models";
import { notificationCountLabel } from "./DeleteSegmentModal";

interface UpdateSegmentNotificationModalProps {
  isOpen: boolean;
  scheduledCount: number;
  draftCount: number;
  isSubmitting: boolean;
  onCancel: () => void;
  onConfirm: (mode: CherryPayApi.NotificationSegmentUpdateMode) => void;
}

export const UpdateSegmentNotificationModal = ({
  isOpen,
  scheduledCount,
  draftCount,
  isSubmitting,
  onCancel,
  onConfirm,
}: UpdateSegmentNotificationModalProps) => {
  const [selectedMode, setSelectedMode] =
    useState<CherryPayApi.NotificationSegmentUpdateMode | null>(null);

  const handleConfirm = () => {
    if (!selectedMode) return;
    onConfirm(selectedMode);
  };

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bg="cherryButton.600" color="white" borderTopRadius="md">
          Update Segment Used by Notifications?
        </ModalHeader>
        <ModalBody pt={5} pb={4}>
          <VStack align="start" spacing={3}>
            <Text>This segment is currently used in:</Text>
            <VStack align="start" spacing={1} pl={2}>
              {scheduledCount > 0 && (
                <Text>
                  &bull; {notificationCountLabel(scheduledCount, "Scheduled")}
                </Text>
              )}
              {draftCount > 0 && (
                <Text>
                  &bull; {notificationCountLabel(draftCount, "Draft")}
                </Text>
              )}
            </VStack>
            <Text>
              Updating the segment will change the audience for those
              notifications.
            </Text>
            <Text>How would you like to proceed?</Text>
            <RadioGroup
              onChange={(val) =>
                setSelectedMode(
                  val as CherryPayApi.NotificationSegmentUpdateMode
                )
              }
              value={selectedMode ?? ""}
            >
              <VStack align="start" spacing={3}>
                <Radio value="Override" colorScheme="red">
                  Override notification filters with the updated segment
                </Radio>
                <Radio value="Keep" colorScheme="red">
                  Keep existing filters for scheduled and draft notifications
                </Radio>
              </VStack>
            </RadioGroup>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onCancel} mr={3} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            colorScheme="cherryButton"
            onClick={handleConfirm}
            isLoading={isSubmitting}
            disabled={!selectedMode || isSubmitting}
          >
            Confirm Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
